import { Component, forwardRef, OnInit, ViewChild } from "@angular/core";
import { ActivationEnd, Router } from "@angular/router";
import { DataElement } from "src/app/shared/models/common";
import { AppState } from "src/app/shared/redux/store";
import { AuthService } from "src/app/shared/services/auth.service";
import { KpiBroshComponent } from "../kpi-brosh/kpi-brosh.component";
import { LabKpiComponent } from "../lab-kpi.component";
import { Store } from "@ngrx/store";
import { GO_TO_CLINIC_KPI } from "src/app/shared/ngrx/ngrx-actions";
import {
  agentClinicList,
  clinicChainList,
  clinicList,
  selectedClinicForKpi,
} from "src/app/shared/ngrx/ngrx-selectors";
import { take } from "rxjs/operators";
import { Observable, Subscription } from "rxjs";
import { Clinic } from "src/app/shared/models/clinic.model";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SelectModule } from "primeng/select";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { CommonModule } from "@angular/common";
import { ClearMultiComponent } from "src/app/shared/components/ui/clear-multi.component";

@Component({
  selector: "app-kpi-clinics",
  templateUrl: "./kpi-clinics.component.html",
  styleUrls: ["./kpi-clinics.component.scss"],
  imports: [
    SelectModule,
    InputWrapComponent,
    TranslateModule,
    FormsModule,
    CommonModule,
    ClearMultiComponent,
    forwardRef(() => LabKpiComponent),
  ],
  standalone: true,
})
export class KpiClinicsComponent {
  @ViewChild("labKpi") cmpLabKpi?: LabKpiComponent;

  selectedClinic: DataElement;
  selectedClinicChain: DataElement;
  filter: string;
  filterType: string;
  loading: boolean;
  clinicChainList = this.store.selectSignal(clinicChainList)();
  showClinicChainFilter: boolean = false;
  showClinicFilter: boolean = false;
  routerSub: Subscription;

  get clinicList(): Clinic[] {
    return this.authService.currentUser.roleCode == "AGENT"
      ? this.store.selectSignal(agentClinicList)()
      : this.store.selectSignal(clinicList)();
  }


  constructor(
    private readonly store: Store,
    private router: Router,
    private authService: AuthService
  ) { }

  ngAfterViewInit(): void {
    this.showClinicChainFilter = this.authService.currentUser.roleCode == "ADMIN";
    this.showClinicFilter = this.authService.currentUser.roleCode == "ADMIN" || this.authService.currentUser.roleCode == "AGENT";

    this.presetClinic();

    this.routerSub = this.router.events.subscribe((ev) => {
      if (
        ev instanceof ActivationEnd &&
        Object.is(ev?.snapshot?.component, KpiClinicsComponent)
      ) {
        this.presetClinic();
      }
    });
  }

  private presetClinic() {
    this.store
      .select(selectedClinicForKpi)
      .pipe(take(1))
      .subscribe((selectedClinicForKpi) => {
        if (selectedClinicForKpi) {
          this.selectedClinic = this.clinicList?.find(
            (c) => c.id == selectedClinicForKpi.toString()
          );
          this.selectedClinic.selected = true;
          this.onClinicValueChanged();

          this.store.dispatch(
            GO_TO_CLINIC_KPI({
              clinicId: null,
            })
          );
        } else if (!this.showClinicFilter && this.clinicList.length > 0) {
          this.selectedClinic = this.clinicList[0]
          this.selectedClinic.selected = true;
          this.onClinicValueChanged();
        }
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();

    this.store.dispatch(
      GO_TO_CLINIC_KPI({
        clinicId: null,
      })
    );
  }

  onClinicValueChanged() {
    this.selectedClinicChain = null;
    this.search();
  }

  onChainValueChanged() {
    this.selectedClinic = null;
    this.search();
  }

  search() {
    if (!this.selectedClinic && !this.selectedClinicChain) {
      this.filterType = null;
      return;
    }

    this.loading = true;

    setTimeout(() => {
      if (this.selectedClinic) {
        this.filterType = "CLINIC";
        this.filter = this.selectedClinic.id;
      } else if (this.selectedClinicChain) {
        this.filterType = "CHAIN";
        this.filter = this.selectedClinicChain.id;
      }

      this.loading = false;
      if (this.cmpLabKpi) {
        this.cmpLabKpi.getData();
      }
    }, 100);
  }
}
